import { useCallback, useEffect, useRef, useState } from 'react';

// Tiny data-fetching helper built on top of the api service. Avoids extra
// dependencies while still giving us loading/error/data semantics.
export const useApi = (loader, deps = []) => {
  const [state, setState] = useState({ data: null, loading: true, error: null });
  const mounted = useRef(true);
  useEffect(() => () => { mounted.current = false; }, []);

  const reload = useCallback(async (...args) => {
    setState((s) => ({ ...s, loading: true, error: null }));
    try {
      const res = await loader(...args);
      if (mounted.current) setState({ data: res, loading: false, error: null });
      return res;
    } catch (err) {
      if (mounted.current) setState({ data: null, loading: false, error: err });
      throw err;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  useEffect(() => { reload(); }, [reload]);

  return { ...state, reload };
};
